// extracted by mini-css-extract-plugin
export var labelWrapper = "_mf-0";